import React, { useEffect, useState } from 'react';
import './App.css';
import { Thirukkural } from './components/Thirukkural';
import { Design } from './components/Design';

function App() {
  return <>
    <Thirukkural />
  </>
}

export default App;
